import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import Cookies from 'universal-cookie';
import { getDaysFromTodayDate } from "../../dateUtils";
var COOKIE_OPTIONS = {
  expires: getDaysFromTodayDate(365),
  path: '/'
};
var cookies = new Cookies();
var CookieStorageMethod = /*#__PURE__*/function () {
  function CookieStorageMethod(cookieName) {
    _classCallCheck(this, CookieStorageMethod);
    this.cookieName = cookieName;
    cookies.set(cookieName, {}, COOKIE_OPTIONS);
  }
  return _createClass(CookieStorageMethod, [{
    key: "get",
    value: function get(key) {
      var data = cookies.getJSON(this.cookieName) || {};
      return data[key];
    }
  }, {
    key: "set",
    value: function set(key, item) {
      var siteData = cookies.getJSON(this.cookieName) || {};
      siteData[key] = item;
      cookies.set(this.cookieName, siteData, COOKIE_OPTIONS);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var siteData = cookies.getJSON(this.cookieName) || {};
      if (siteData.hasOwnProperty(key)) {
        delete siteData[key];
        cookies.set(this.cookieName, siteData, COOKIE_OPTIONS);
      }
    }
  }]);
}();
export { CookieStorageMethod as default };